module.exports = __webpack_public_path__ + "img/HYPERS.4a732ce8.png";